exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0c125719]::-webkit-scrollbar{width:0;background-color:transparent}", ""]);

// exports
